import { ProductType } from "@/constants/productTypes";

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCTS_TYPE = 'SET_PRODUCT_TYPE';
export const SET_PRODUCT = 'SET_PRODUCT';

export const SET_PRODUCT_HISTORY = 'SET_PRODUCT_HISTORY';
export const DISPLAY_PRODUCT_HISTORY = 'DISPLAY_PRODUCT_HISTORY';

export const TOGGLE_PRODUCT_TABLE = 'TOGGLE_PRODUCT_TABLE';

export const SET_PRODUCT_CONTRACTS = 'SET_PRODUCT_CONTRACTS';

export const REFRESH_SOFTWARE = 'REFRESH_SOFTWARE';


export type ProductTypePayload = {
  type: ProductType
  data: any
}


// WEBPACK FOOTER //
// ./src/store/modules/products/types.ts